import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from "@mui/material/Typography";
import { IconButton, Box, LinearProgress } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from 'moment-timezone';
// import {generateCSV} from "../../../utils/GenerateCSV";
import {withTranslation} from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import errorData from "../../common/twilio-error-codes.json"
import download from '../images/download-doc.svg';
import ILocalAGGrid, {
    getDefaultColDef,
    createServerSideDatasource,
    withDateColumnFilter,
    applyReportFilterModel,
    attachReportServerSideDatasource,
} from "../../grid/iLocalAGGrid";
import { ReportToolbar } from "../ReportPageLayout";

function TabContainer({ children, dir, classes }) {
    return (
        <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};


class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {order, orderBy, sortId, t} = this.props;
        const rows = [
            { id: "created_on", numeric: false, disablePadding: false, label: "Date", padding: '8px', field: 'created_on' },
            { id: "receiver_name", numeric: false, disablePadding: false, label: "Name", padding: '8px', field: 'receiver_name' },
            { id: "phone", numeric: false, disablePadding: false, label: "Destination", padding: '8px', field: 'phone' },
            { id: "carrier", numeric: false, disablePadding: false, label: "Type", padding: '8px', field: 'carrier' },
            { id: "store", numeric: false, disablePadding: false, label: "Store", padding: '8px', field: 'name' },
            { id: "box", numeric: false, disablePadding: false, label: "Box", padding: '8px', field: 'name' },
            { id: "content", numeric: false, disablePadding: false, label: "Content", padding: '8px', field: 'content' },
            { id: "status", numeric: false, disablePadding: false, label: "Status", padding: '8px', field: 'status' },
        ];

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}>
                                {
                                    <Tooltip
                                        title={t("Global.Label.Filter.Sort")}
                                        placement={row.numeric ? "bottom-end" : "bottom-start"}
                                        enterDelay={300}>
                                        <TableSortLabel
                                            active={orderBy === row.field && sortId === row.id}
                                            direction={order}
                                            onClick={this.createSortHandler(row.id, row.field)}>
                                            {row.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                }
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    },
    padding10px: {
        padding: '10px'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    },
    rowheight: {
        height: '35px'
    },
    primaryButton: {
        background: '#6cca98',
        color: '#fff',
        '&:hover': {
            background: '#6cca98',
            color: '#fff',
        },
        '&:disabled': {
            color: 'rgba(0, 0, 0, 0.38)',
            cursor: 'not-allowed',
            background: '#E4E5E8'
        },
    }
});

const MESSAGE_LOG_EXPORT_PAGE_SIZE = 2500;

let TransactionFilterObj = {
    store_ids: [],
    box_ids: [],
    searchtext: '',
    fromdate: '',
    todate: '',
    pageNo: 0,
    pageSize: 10,
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: '',
    group_id: null,
    timezone: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            order: "desc",
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            dateRangePreset: 'last7days',
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            isDataEmpty: true,
            selectedTab: 0,
            totalRecords: 0,
            isButtonDisabled: false,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
            contentData: '',
            carrierType: '',
            queryId: "",
            groups: [],
            fromDateError: '',
            toDateError: '',
            isExporting: false,
            exportStatusMessage: '',
            exportBatchCurrent: 0,
            exportBatchTotal: null,
            exportRecordsLoaded: 0,
            exportTotalRecords: null,
            exportPhase: null,
        };
        this.handleStoreChange = this.handleStoreChange.bind(this);
        this.handleBoxChange = this.handleBoxChange.bind(this);
        this.debouceTimeout = null;
    }

    componentDidMount() {
        TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
        let userTimeZone = sessionStorage.getItem('timeZone');
        if (['null', null, 'undefined', undefined, ''].includes(userTimeZone)) {
            userTimeZone = defaultZone;
        }
        TransactionFilterObj.timezone = userTimeZone.substring(userTimeZone.lastIndexOf(' ') + 1);
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + "accounts", {
            method: 'GET',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(accounts => {
                const {t} = this.props;
                let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
                const storelist = accounts.map(account => {
                    return { id: account.id, name: account.name };
                });

                const accountValues = All.concat(storelist);
                this.setState({ accountValues, parent_account_id: accountValues[0].id });
                this.BindBoxesbyStoreId(storelist.map(x => x.id));
                this.setState({ loader: false });
            });
        // Set default date range (T-30 days to today)
        const defaultDates = getDefaultDateRange();
        this.setState({
            fromdate: defaultDates.fromDate,
            todate: defaultDates.toDate,
            dateRangePreset: 'last7days'
        });

        Object.assign(TransactionFilterObj, {
            store_ids: [],
            box_ids: [],
            searchtext: '',
            fromdate: formatFromDateForAPI(defaultDates.fromDate),
            todate: formatToDateForAPI(defaultDates.toDate),
            pageNo: 0,
            pageSize: 10,
            sortOrder: 'desc',
            sortColumn: 'created_on',
            tableName: '',
            timezone: TransactionFilterObj.timezone});
        this.fetchSuggestions()
        // SSRM datasource attaches in onGridReady; avoid a parallel legacy fetch.
    }

    getRowId = (params) => {
        const d = params.data || {};
        if (d.__ssrmId) return String(d.__ssrmId);
        return String(
            d.id ||
                [d.created_on, d.phone, d.carrier, d.receiver_name, d.store, d.box]
                    .filter((v) => v != null && String(v).trim() !== '')
                    .join('|') ||
                `row-${Math.random().toString(36).slice(2)}`
        );
    };

    refreshGrid = () => {
        if (!this.gridApi) return;
        if (typeof this.gridApi.refreshServerSideStore === 'function') {
            this.gridApi.refreshServerSideStore({ purge: true });
        } else if (typeof this.gridApi.refreshServerSide === 'function') {
            this.gridApi.refreshServerSide({ purge: true });
        }
    };

    onPaginationChanged = (params) => {
        if (!params.api) return;
        const newPageSize = params.api.paginationGetPageSize();
        if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
            TransactionFilterObj.pageSize = newPageSize;
        }
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this._agFilterBody = TransactionFilterObj;
        const datasource = createServerSideDatasource({
            filterBody: TransactionFilterObj,
            applyFilterModel: (body, filterModel) => {
                applyReportFilterModel(body, filterModel, {
                    dateColIds: ['created_on'],
                });
            },
            sortMap: {
                created_on: { tableName: 'system_log', sortColumn: 'created_on' },
                receiver_name: { tableName: 'system_log', sortColumn: 'receiver_name' },
                phone: { tableName: 'system_log', sortColumn: 'phone' },
                carrier: { tableName: 'system_log', sortColumn: 'carrier' },
                store: { tableName: 'accounts', sortColumn: 'name' },
                box: { tableName: 'boxes', sortColumn: 'name' },
                status: { tableName: 'system_log', sortColumn: 'status' },
            },
            pageZeroBased: true,
            getPageSize: () => TransactionFilterObj.pageSize || 10,
            fetchPage: (body) =>
                fetch(process.env.REACT_APP_BASEURL + 'getMessageLog', {
                    method: 'post',
                    withCredentials: true,
                    headers: {
                        Authorization:
                            'Bearer ' +
                            JSON.parse(sessionStorage.getItem('user')).signInUserSession
                                .idToken.jwtToken,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        ...body,
                        store_ids: Array.isArray(body.store_ids) ? body.store_ids : [],
                        box_ids: Array.isArray(body.box_ids) ? body.box_ids : [],
                        searchtext: body.searchtext || '',
                        fromdate: body.fromdate || '',
                        todate: body.todate || '',
                    }),
                }).then((r) => r.json()),
            onSuccess: (results, total) => {
                setTimeout(() => {
                    this.setState({
                        data: results,
                        totalRecords: total,
                        loader: false,
                        isDataEmpty: !results || results.length === 0,
                        isButtonDisabled: !results || results.length === 0,
                    });
                }, 0);
            },
            onError: () => this.setState({ loader: false }),
        });
        attachReportServerSideDatasource(
            params,
            datasource,
            TransactionFilterObj,
            'created_on'
        );
    };

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng') || 'en';
        let zone = sessionStorage.getItem('timeZone') || defaultZone;

        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }

        const timeZoneName = zone.substring(zone.lastIndexOf(' ') + 1);

        const date = moment.utc(requestDate).tz(timeZoneName);
        return currentUserLang === 'en'
            ? date.format('MM/DD/YYYY hh:mm:ss A')
            : date.format('DD/MM/YYYY hh:mm:ss A');
    };

    gettingOnSortTableName = (field) => {
        let tablename = '';
        if (['created_on', 'phone', 'carrier', 'status'].includes(field)) {
            tablename = 'system_log';
        }
        if (['box'].includes(field)) {
            tablename = 'boxes';
        }
        if (['store'].includes(field)) {
            tablename = 'accounts';
        }
        return tablename;
    }

    handleRequestSort = (event, property, field) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.orderBy === orderBy) {
            order = this.state.order === "asc" ? "desc" : "asc";
        } else if (this.state.order === order) {
            order = "asc";
        } else {
            order = "desc";
        }
        this.setState({ order, orderBy, sortId: property });
        TransactionFilterObj.sortOrder = order;
        TransactionFilterObj.sortColumn = field;
        TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);

        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangePage = (event, page) => {
        event && event.preventDefault();

        TransactionFilterObj.pageNo = page;
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangeRowsPerPage = event => {

        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.pageSize = event.target.value;
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    //Bind Boxes by store id
    BindBoxesbyStoreId(store_ids) {
        if (store_ids.length > 0) {
            this.setState({ loader: true });
            let BoxesObj = {
                store_ids: store_ids
            }
            fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
                method: 'post',
                withCredentials: true,
                headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(BoxesObj)
            })
                .then(response => {
                    try {
                        return response.json();
                    } catch (error) {
                        return null;
                    }
                })
                .then(data => {
                    const {t} = this.props;
                    let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
                    const boxlist = data.map(account => {
                        return { id: account.id, name: account.name };
                    });
                    const boxvalues = All.concat(boxlist);
                    this.setState({ chipboxes: [] });
                    this.setState({ nboxes: [] });
                    this.setState({ boxvalues: boxvalues });
                    this.setState({ loader: false });
                });
        }
    }

    handleStoreChange = event => {
        const storeid = event.target.value;
        const storeids = [];
        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');

        if (AllprocessedIndex > -1) {
            chipprocessed = [this.state.accountValues[0]];
            for (let i = 0; i < this.state.accountValues.length; i++) {
                processed.push(this.state.accountValues[i]);
            }
        }
        else if (storeid.length === 0) {
            chipprocessed = [];
            processed = [];
        }
        else if (storeid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
            }
        }

        this.setState({ chipstores: chipprocessed });
        this.setState({ nstores: processed });

        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    storeids.push(processed[i].id)
                }
            }
        }
        this.setState({ store_id: storeids });
        TransactionFilterObj.store_ids = storeids;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        this.BindBoxesbyStoreId(storeids);
        this.BindGrid();
    };

    handleBoxChange = event => {
        const boxid = event.target.value;
        const boxids = [];

        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');

        if (AllprocessedIndex > -1) {
            chipprocessed = [this.state.boxvalues[0]];
            for (let i = 0; i < this.state.boxvalues.length; i++) {
                processed.push(this.state.boxvalues[i]);
            }
        }
        else if (boxid.length === 0) {
            chipprocessed = [];
            processed = [];
        }
        else if (boxid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
            }
        }

        this.setState({ chipboxes: chipprocessed });
        this.setState({ nboxes: processed });

        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    boxids.push(processed[i].id)
                }
            }
        }
        this.setState({ box_id: boxids });
        TransactionFilterObj.box_ids = boxids;
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        this.BindGrid();
    };

    handleDeleteStoreChip = (chipToDelete) => (event) => {
        event.stopPropagation();
        if (chipToDelete.id === '-1') {
            this.setState({ chipstores: [], nstores: [], store_id: [] });
            TransactionFilterObj.store_ids = [];
            TransactionFilterObj.pageNo = 0;
            this.BindBoxesbyStoreId([]);
            this.BindGrid();
            return;
        }
        const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
        const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
        this.setState({ chipstores: updatedStores, nstores: updatedNStores });
        const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
        this.BindBoxesbyStoreId(storeids);
        TransactionFilterObj.store_ids = storeids;
        TransactionFilterObj.pageNo = 0;
        this.BindGrid();
    };

    handleDeleteBoxChip = (chipToDelete) => (event) => {
        event.stopPropagation();
        if (chipToDelete.id === '-1') {
            this.setState({ chipboxes: [], nboxes: [], box_id: [] });
            TransactionFilterObj.box_ids = [];
            TransactionFilterObj.pageNo = 0;
            this.BindGrid();
            return;
        }
        const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
        const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
        this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
        const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
        TransactionFilterObj.box_ids = boxids;
        TransactionFilterObj.pageNo = 0;
        this.BindGrid();
    };

    handleClearAllStores = (event) => {
        event.stopPropagation();
        this.setState({ chipstores: [], nstores: [], store_id: [] });
        TransactionFilterObj.store_ids = [];
        TransactionFilterObj.pageNo = 0;
        this.BindBoxesbyStoreId([]);
        this.BindGrid();
    };

    handleClearAllBoxes = (event) => {
        event.stopPropagation();
        this.setState({ chipboxes: [], nboxes: [], box_id: [] });
        TransactionFilterObj.box_ids = [];
        TransactionFilterObj.pageNo = 0;
        this.BindGrid();
    };

    onSearchChange = (event) => {
        this.debouceTimeout && clearInterval(this.debouceTimeout);
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.searchtext = searchString;
        this.debouceTimeout = setTimeout(() => {
            this.BindGrid();
        }, 1000)
    }

    onFromDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ fromdate: dateObj, fromDateError: '', dateRangePreset: '' });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    };

    onToDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ todate: dateObj, toDateError: '', dateRangePreset: '' });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    };

    handleBlurfrom = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            fromdate: dateObj,
            dateRangePreset: ''
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = ''
        TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    }

    handleBlurtodate = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            todate: dateObj,
            dateRangePreset: ''
        });
        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = ''
        TransactionFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    }

    handleDateRangePresetChange = (event) => {
        const preset = event.target.value;
        if (!preset) return;

        const dateRange = getDateRangeByPreset(preset);
        this.setState({
            fromdate: dateRange.fromDate,
            todate: dateRange.toDate,
            dateRangePreset: preset,
            fromDateError: '',
            toDateError: ''
        });

        TransactionFilterObj.pageNo = 0;
        TransactionFilterObj.sortOrder = 'desc';
        TransactionFilterObj.sortColumn = 'created_on';
        TransactionFilterObj.tableName = '';
        TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
        TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
        this.BindGrid();
    };

    handleUpdateMessageLog = () => {
        this.setState({ loader: true });
        const parent_id = sessionStorage.getItem('parentAccountId');
        const updateObj = {
            accountId: parent_id
        }
        fetch(process.env.REACT_APP_BASEURL + 'updateSystemLog', {
            method: 'post',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateObj)
        })
            .then(response => {
                this.setState({ loader: false });
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    async BindGrid() {
        if (this.gridApi) {
            this.refreshGrid();
            return;
        }
        // SSRM datasource is attached in onGridReady; avoid a parallel
        // legacy fetch/setState race that leaves the grid empty.
        this.setState({ loader: false });
    }

    handleContentClick = (event, data) => {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
        if (!data) return;
        let response = {};
        try {
            response = data.response ? JSON.parse(data.response) : {};
        } catch (e) {
            response = {};
        }
        const infoMessage = ![undefined, 'undefined', null, 'null', ''].includes(response.code)
            ? errorData.find((errorObj) => errorObj.code === response.code)
            : { description: data.status };
        let content = '';
        try {
            content = ![undefined, 'undefined', null, 'null', ''].includes(data.request_body)
                ? JSON.parse(data.request_body)
                : '';
        } catch (e) {
            content = data.request_body || '';
        }
        const _data = {
            content,
            status: [null, 'null'].includes(infoMessage && infoMessage.description)
                ? (infoMessage && infoMessage.message)
                : (infoMessage && infoMessage.description),
        };
        this.setState({ detailDialogOpen: true, contentData: _data, carrierType: data.carrier });
    }

    handleContentClose = (event) => {
        event.preventDefault();
        this.setState({ detailDialogOpen: false, selectedTab: 0 })
    }

    handleTabChange = (event, index) => {
        this.setState({ selectedTab: index });
    };

    handleChangeIndex(index) {
        this.setState({ selectedTab: index });
    };

    getColor = (isOfflinePickup) => {
        if (isOfflinePickup === true)
            return { bgColor: '#00a7e1', fontColor: '#fff' };
        else
            return { bgColor: '#fff', fontColor: 'rgba(0, 0, 0, 0.87)' };
    };

    getLinkColor = (isOfflinePickup) => {
        if (isOfflinePickup === true)
            return '#fff';
        else
            return '#385cad';
    };

    handleUpdateLog = () => {
        this.setState({ loader: true });
        const parent_id = sessionStorage.getItem('parentAccountId');
        const updateObj = {
            accountId: parent_id
        }
        fetch(process.env.REACT_APP_BASEURL + 'updateSystemLog', {
            method: 'post',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateObj)
        })
            .then(response => {
                this.setState({ loader: false });
                this.BindGrid();
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    handleInputChange = (event) => {
        this.setState({ queryId: event.target.value });
        TransactionFilterObj.group_id = event.target.value;
        this.BindGrid();
    };

    fetchSuggestions = async () => {
        try {
            const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
                method: "GET",
                withCredentials: true,
                headers: {
                    Authorization:
                        "Bearer " +
                        JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                            .jwtToken,
                    "Content-Type": "application/json",
                },
            }
            );
            result
                .then((result) => {
                    result.json().then((resLocation) => {
                        this.setState({ groups: resLocation && resLocation.data })
                    })
                })
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    getAuthHeaders = () => ({
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
    });

    clearExportProgress = () => {
        this.setState({
            isExporting: false,
            exportStatusMessage: '',
            exportBatchCurrent: 0,
            exportBatchTotal: null,
            exportRecordsLoaded: 0,
            exportTotalRecords: null,
            exportPhase: null,
        });
    };

    updateExportProgress = (progress) => {
        const {t} = this.props;
        const {
            phase,
            batchCurrent = 0,
            batchTotal = null,
            recordsLoaded = 0,
            totalRecords = null,
        } = progress;

        let exportStatusMessage = '';
        if (phase === 'preparing') {
            exportStatusMessage = t('Report.MessageLog.ExportPreparing', { defaultValue: 'Preparing export...' });
        } else if (phase === 'fetching') {
            if (batchTotal) {
                exportStatusMessage = t('Report.MessageLog.ExportFetchingBatch', {
                    defaultValue: 'Downloading batch {{current}} of {{total}} ({{records}} of {{totalRecords}} records)',
                    current: batchCurrent,
                    total: batchTotal,
                    records: recordsLoaded,
                    totalRecords: totalRecords || recordsLoaded,
                });
            } else {
                exportStatusMessage = t('Report.MessageLog.ExportFetchingBatchUnknown', {
                    defaultValue: 'Downloading batch {{current}}... ({{records}} records loaded)',
                    current: batchCurrent,
                    records: recordsLoaded,
                });
            }
        } else if (phase === 'building') {
            exportStatusMessage = t('Report.MessageLog.ExportBuildingCsv', {
                defaultValue: 'Building CSV file... ({{records}} records)',
                records: recordsLoaded,
            });
        }

        this.setState({
            exportPhase: phase,
            exportBatchCurrent: batchCurrent,
            exportBatchTotal: batchTotal,
            exportRecordsLoaded: recordsLoaded,
            exportTotalRecords: totalRecords,
            exportStatusMessage,
        });
    };

    getExportProgressPercent = () => {
        const {exportPhase, exportBatchCurrent, exportBatchTotal, exportRecordsLoaded, exportTotalRecords} = this.state;
        if (exportPhase === 'building') {
            return 100;
        }
        if (exportTotalRecords && exportTotalRecords > 0) {
            return Math.min(99, Math.round((exportRecordsLoaded / exportTotalRecords) * 100));
        }
        if (exportBatchTotal && exportBatchTotal > 0) {
            return Math.min(99, Math.round((exportBatchCurrent / exportBatchTotal) * 100));
        }
        return 0;
    };

    fetchAllMessageLogForExport = async () => {
        const allResults = [];
        let pageNo = 0;
        let batchTotal = null;
        let totalRecords = null;

        this.updateExportProgress({ phase: 'preparing' });

        while (true) {
            const batchCurrent = pageNo + 1;
            this.updateExportProgress({
                phase: 'fetching',
                batchCurrent,
                batchTotal,
                recordsLoaded: allResults.length,
                totalRecords,
            });

            const response = await fetch(process.env.REACT_APP_BASEURL + 'getMessageLog', {
                method: 'POST',
                withCredentials: true,
                headers: this.getAuthHeaders(),
                body: JSON.stringify({
                    ...TransactionFilterObj,
                    pageNo,
                    pageSize: MESSAGE_LOG_EXPORT_PAGE_SIZE,
                }),
            });

            if (!response.ok) {
                throw new Error(`Export request failed (${response.status})`);
            }

            let pageData;
            try {
                pageData = await response.json();
            } catch (error) {
                throw new Error('Invalid response while exporting message log');
            }

            if (pageData && pageData.message) {
                throw new Error(pageData.message);
            }

            const batch = pageData && pageData.results ? pageData.results : [];
            if (pageNo === 0 && pageData && typeof pageData.total === 'number') {
                totalRecords = pageData.total;
                batchTotal = totalRecords > 0
                    ? Math.ceil(totalRecords / MESSAGE_LOG_EXPORT_PAGE_SIZE)
                    : 1;
            }

            allResults.push(...batch);

            this.updateExportProgress({
                phase: 'fetching',
                batchCurrent,
                batchTotal,
                recordsLoaded: allResults.length,
                totalRecords,
            });

            if (batch.length < MESSAGE_LOG_EXPORT_PAGE_SIZE) {
                break;
            }
            pageNo += 1;
        }

        this.updateExportProgress({
            phase: 'building',
            batchCurrent: batchTotal || pageNo + 1,
            batchTotal: batchTotal || pageNo + 1,
            recordsLoaded: allResults.length,
            totalRecords: totalRecords || allResults.length,
        });

        return allResults;
    };

    buildMessageLogCsv = (results) => {
        const rows = [
            ['Id', 'Date', 'Name', 'Destination', 'Type', 'Store', 'Box', 'Request Body', 'Response', 'Status']
        ];

        results.forEach((item, index) => {
            rows.push([
                index + 1,
                item.created_on ? `="${this.convertToTimeZone(item.created_on)}"` : '',
                item.receiver_name || '',
                item.phone || '',
                item.carrier || '',
                item.store || '',
                item.box || '',
                item.request_body || '',
                item.response || '',
                [undefined, 'undefined', null, 'null', '', 400, '400'].includes(item.status)
                    ? "Failed"
                    : (typeof item.status === 'string' && item.status.length > 0
                        ? item.status.charAt(0).toUpperCase() + item.status.slice(1)
                        : item.status)
            ]);
        });

        return rows.map(e => e.map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")).join("\r\n");
    };

    downloadCsvBlob = (csvContent, filename) => {
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    renderExportButton = () => {
        const {t} = this.props;
        const isExportDisabled = !this.state.fromdate || !this.state.todate || this.state.isExporting;
        const exportTooltip = isExportDisabled
            ? t("Report.MessageLog.ExportDatesRequiredTooltip")
            : t("Report.MessageLog.ExportCSVTooltip");

        return (
            <Tooltip title={exportTooltip} arrow describeChild>
                <span style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                    <IconButton
                        style={{ marginRight: '0' }}
                        aria-label="ExportCSV"
                        onClick={() => { this.exportCSV() }}
                        disabled={isExportDisabled}>
                        <img
                            alt="download"
                            src={download}
                            style={{
                                height: '32px',
                                width: '32px',
                                cursor: isExportDisabled ? 'not-allowed' : 'pointer',
                                opacity: isExportDisabled ? 0.45 : 1,
                            }}
                        />
                    </IconButton>
                </span>
            </Tooltip>
        );
    };

    exportCSV = async () => {
        const {t} = this.props;
        const hasFromDate = Boolean(TransactionFilterObj.fromdate);
        const hasToDate = Boolean(TransactionFilterObj.todate);
        let hasError = false;

        if (!hasFromDate) {
            this.setState({ fromDateError: t('Report.MessageLog.FromDateRequired', { defaultValue: 'From Date is required' }) });
            hasError = true;
        } else {
            this.setState({ fromDateError: '' });
        }
        if (!hasToDate) {
            this.setState({ toDateError: t('Report.MessageLog.ToDateRequired', { defaultValue: 'To Date is required' }) });
            hasError = true;
        } else {
            this.setState({ toDateError: '' });
        }
        if (hasError) return;

        this.setState({ isExporting: true });

        try {
            const results = await this.fetchAllMessageLogForExport();

            if (!results.length) {
                alert(t('Report.Transaction.NoDataFound', { defaultValue: 'No Data Found' }));
                return;
            }

            const csvContent = this.buildMessageLogCsv(results);
            this.downloadCsvBlob(csvContent, 'MessagelogReport.csv');
        } catch (error) {
            console.error("CSV export failed", error);
            alert(
                t('Report.MessageLog.ExportError', {
                    defaultValue: 'Failed to export message log. Try narrowing the date range or filters, then try again.',
                }) + (error && error.message ? ` (${error.message})` : '')
            );
        } finally {
            this.clearExportProgress();
        }
    }

    renderExportOverlay = () => {
        const {classes} = this.props;
        const {isExporting, exportStatusMessage} = this.state;

        if (!isExporting) {
            return null;
        }

        const progressPercent = this.getExportProgressPercent();
        const showDeterminateProgress = progressPercent > 0;

        return (
            <div className={classes.spinner}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                        minWidth: '320px',
                        maxWidth: '480px',
                        px: 3,
                    }}
                >
                    <img className={classes.spinnerImage} src={spinner} alt="loading" style={{ position: 'relative', top: 0, left: 0 }} />
                    <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 600, color: 'rgba(0, 0, 0, 0.87)' }}>
                        {exportStatusMessage}
                    </Typography>
                    <LinearProgress
                        variant={showDeterminateProgress ? 'determinate' : 'indeterminate'}
                        value={showDeterminateProgress ? progressPercent : undefined}
                        sx={{ mt: 2, height: 8, borderRadius: 4 }}
                    />
                    {showDeterminateProgress ? (
                        <Typography variant="caption" sx={{ mt: 1, display: 'block', color: 'rgba(0, 0, 0, 0.6)' }}>
                            {progressPercent}%
                        </Typography>
                    ) : null}
                </Box>
            </div>
        );
    }

    render() {
        const {classes, theme, t} = this.props;
        return (
            <Paper>
                {this.renderExportOverlay()}
                {
                    this.state.loader && !this.state.isExporting ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
                <div id="react-no-print">
                    <Dialog
                        open={this.state.detailDialogOpen}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        PaperProps={{ style: { borderRadius: '5px', maxWidth: '100%', width: '50%' } }}>
                        <AppBar position="static" color="default">
                            <Tabs
                                value={this.state.selectedTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant={null}>
                                <Tab label="Content" />
                                <Tab label="Status" />
                            </Tabs>
                        </AppBar>
                        <SwipeableViews
                            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                            index={this.state.selectedTab}
                            onChangeIndex={() => this.handleChangeIndex}>
                            <TabContainer dir={theme.direction}>
                                <DialogContent>
                                    {this.state.carrierType === 'Email' ?
                                        <div dangerouslySetInnerHTML={{ __html: this.state.contentData.content }} /> :
                                        <div style={{ whiteSpace: 'pre-wrap' }}>{this.state.contentData.content}</div>
                                    }
                                </DialogContent>
                            </TabContainer>
                            <TabContainer dir={theme.direction}>
                                <DialogContent>
                                    {this.state.contentData.status}
                                </DialogContent>
                            </TabContainer>
                        </SwipeableViews>
                        <DialogActions>
                            <Button onClick={(e) => { this.handleContentClose(e) }} color="primary" className={classes.primaryButton}>
                                {t("Report.Picked.Temperature.CloseButton")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <ReportToolbar>
                  {this.renderExportButton()}
                  <IconButton onClick={this.handleUpdateLog}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path fill="#727272" d="M13.5 2c-5.621 0-10.211 4.443-10.475 10h-3.025l5 6.625 5-6.625h-2.975c.257-3.351 3.06-6 6.475-6 3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5c-1.863 0-3.542-.793-4.728-2.053l-2.427 3.216c1.877 1.754 4.389 2.837 7.155 2.837 5.79 0 10.5-4.71 10.5-10.5s-4.71-10.5-10.5-10.5z" />
                    </svg>
                  </IconButton>
                </ReportToolbar>

                <div className={classes.tableWrapper}>
                              <ILocalAGGrid
            columnDefs={[
              withDateColumnFilter({
                field: 'created_on',
                colId: 'created_on',
                headerName: "Date",
                minWidth: 180,
                valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '',
              }),
              { field: 'receiver_name', headerName: "Name", colId: 'receiver_name', minWidth: 140 },
              { field: 'phone', headerName: "Destination", colId: 'phone', minWidth: 140 },
              { field: 'carrier', headerName: "Type", colId: 'carrier', minWidth: 100 },
              { field: 'store', headerName: "Store", colId: 'store', minWidth: 140 },
              { field: 'box', headerName: "Box", colId: 'box', minWidth: 120 },
              {
                field: 'content',
                headerName: "Content",
                colId: 'content',
                minWidth: 90,
                maxWidth: 110,
                flex: 0,
                sortable: false,
                filter: false,
                cellRenderer: (params) => {
                  const row = params.data;
                  if (!row) return '';
                  return (
                    <IconButton
                      aria-label="View message"
                      size="small"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onClick={(e) => this.handleContentClick(e, row)}>
                      <VisibilityIcon style={{ fontSize: 20, color: '#727272' }} />
                    </IconButton>
                  );
                },
              },
              {
                field: 'status',
                headerName: "Status",
                colId: 'status',
                minWidth: 120,
                valueFormatter: (p) =>
                  [undefined, 'undefined', null, 'null', '', 400, '400'].includes(p.value)
                    ? 'Failed'
                    : (p.value && p.value.length > 0
                        ? p.value.charAt(0).toUpperCase() + p.value.slice(1)
                        : ''),
              },
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={(TransactionFilterObj.pageSize || 10)}
            paginationPageSize={(TransactionFilterObj.pageSize || 10)}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={this.getRowId}
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
          </div>
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/message-log/index.js